import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import { useRemoveConfigs } from './_requests/removeConfigs'
import {
  useOpenServiceOrderAutomaticDistributionEditModal,
  useOpenSlaConfigEditModal
} from '../../../utils/routes/modals/modalsActions'

export const useConfigsActions = (item, ids) => {
  const canDelete = useSessionPermission('useAutomaticDistribution')
  const canEdit = useSessionPermission('useAutomaticDistribution')
  const { t } = useTranslation('common')

  const openEditModal = useOpenServiceOrderAutomaticDistributionEditModal()

  const [deleteItems, { loading }] = useRemoveConfigs()

  const singleOptions = [
    ...appendIf(canEdit, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openEditModal(item)
    }),
    ...appendIf(canDelete, {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems([item.id])
    })
  ]

  const multiOptions = []

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, loading]
}

export const useSlaConfigsActions = (item, ids) => {
  const openEditSlaModal = useOpenSlaConfigEditModal()
  const { t } = useTranslation('common')

  const [deleteItems, { loading }] = useRemoveConfigs()

  const singleOptions = [
    {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openEditSlaModal(item)
    },
    {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems([item.id])
    }
  ]

  const multiOptions = []

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, loading]
}
